import client from "../api-client";

const URL = "admin/banlogin";

export const get = () => {
  return client(URL).then(async (response) => {
    return await response;
  });
};

export const add = async (data) => {
  return await client(URL, { method: "PUT", body: data });
};

export const remove = async (data) => {
  return await client(URL, { method: "DELETE", body: data });
};
